import React from 'react';
export function WhoIsItFor() {
  return <section className="py-12 px-4 bg-soft-rose/30" data-id="element-331">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-332">
        {/* ES para vos */}
        <div className="bg-white p-6 md:p-8 rounded-3xl shadow-soft border-t-8 border-green-400" data-id="element-333">
          <h3 className="text-xl md:text-2xl font-bold mb-6 text-warm-brown-dark" data-id="element-334">
            Este método ES para vos si…
          </h3>
          <ul className="space-y-3" data-id="element-335">
            {['Querés sanar de raíz y no solo "manejar síntomas".', 'Estás lista para mirar tu historia familiar con honestidad y compasión.', 'Creés que el cuerpo y el alma son un mismo territorio.', 'Tenés ganas de usar herramientas prácticas (rituales, mantras, meditaciones).', 'Querés ser la mujer que rompe los ciclos de dolor para las que vienen después.', 'Buscás un proceso profundo que vaya más allá de lo superficial.'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-336">
                <span className="text-green-500 mt-0.5 flex-shrink-0 text-sm" data-id="element-337">
                  ✅
                </span>
                <span className="text-base text-warm-brown-dark" data-id="element-338">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* NO es para vos */}
        <div className="bg-white p-6 md:p-8 rounded-3xl shadow-soft border-t-8 border-red-400" data-id="element-339">
          <h3 className="text-xl md:text-2xl font-bold mb-6 text-warm-brown-dark" data-id="element-340">
            Este método NO es para vos si…
          </h3>
          <ul className="space-y-3" data-id="element-341">
            {['Buscás una pastilla mágica sin comprometerte con el proceso.', 'No estás dispuesta a mirar con honestidad tu relación con tu madre.', 'Querés reemplazar una terapia psicológica o tratamiento médico.', 'No creés en la conexión entre cuerpo, mente y linaje.'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-342">
                <span className="text-red-500 mt-0.5 flex-shrink-0 text-sm" data-id="element-343">
                  ❌
                </span>
                <span className="text-base text-warm-brown-dark" data-id="element-344">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}